import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Download, ExternalLink, Power } from 'lucide-react';

const StartMenu = ({ isOpen, windows, onItemClick, onResumeDownload, onResumeOpen }) => (
  <AnimatePresence>
    {isOpen && (
      <motion.div
        className="start-menu"
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 20, opacity: 0 }}
      >
        <div className="start-menu-header">
          <div className="start-user">
            <div className="user-avatar">OE</div>
            <span>Ossama Elhelali</span>
          </div>
        </div>

        <div className="start-menu-items">
          {windows.map(w => (
            <button key={w.id} className="start-menu-item" onClick={() => onItemClick(w.id)}>
              <span className="menu-icon">
                {w.Icon && <w.Icon size={18} strokeWidth={1.5} />}
              </span>
              <span>{w.title}</span>
            </button>
          ))}

          <div className="menu-divider" />

          <button className="start-menu-item" onClick={onResumeOpen}>
            <span className="menu-icon">
              <ExternalLink size={18} strokeWidth={1.5} />
            </span>
            <span>View Resume</span>
          </button>
          <button className="start-menu-item" onClick={onResumeDownload}>
            <span className="menu-icon">
              <Download size={18} strokeWidth={1.5} />
            </span>
            <span>Download Resume</span>
          </button>
        </div>

        <div className="start-menu-footer">
          <button className="power-btn" onClick={() => window.location.reload()}>
            <Power size={14} strokeWidth={1.5} /> Restart
          </button>
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);

export default StartMenu;
